const CertificationInfoConfirm = ({fields, cert1Checks, viewMode, member}) => {

  const qcquiredItems = [
      '日本スポーツ協会公認スポーツドクター',
      '日本整形外科学会認定スポーツ医',
      '日本医師会健康スポーツ医',
      '日本障がい者スポーツ協会障がい者スポーツ医',
      '日本スポーツ協会公認スポーツデンティスト',
      'なし'
  ];

  const getAcquiredItems = () => {
    if (!cert1Checks) return;
    let arr = [];
    for (let i = 0; i < cert1Checks.length; i++) {
	if (0 != cert1Checks[i]) arr.push(qcquiredItems[i]);
    }
    return arr.join();
  };
    
  return (
    <>
              <h3>資格</h3>
              <dl>
                <dt>医籍登録番号<span class="red">*</span></dt>
                <dd>{viewMode ? member.medicalRegistrationNumber : fields.medicalRegistrationNumber}&nbsp;</dd>
                <dt>取得年月日<span class="red">*</span></dt>
          <dd>{viewMode ? member.certifiedDate : fields.certifiedDate} &nbsp;</dd>
                
                <dt>取得スポーツ医資格<span class="red">*</span></dt>
          <dd> { getAcquiredItems() }&nbsp;</dd>
              </dl>
              <h3 className="glbHidden">学位</h3>
              <dl className="glbHidden">
                <dt>学位<span class="red">*</span></dt>
                <dd>{ viewMode ? member.degree  :  fields.degree }&nbsp;</dd>
              </dl>
    </>
  );
}

export default CertificationInfoConfirm;
